/*
  Vuetify does not currently support date sorting.
  This is an attempt to introduce the feature without ripping the data table
  out of the application in an effort to implement date sorting.
  Hopefully this file can be removed one day.
*/

export default {
  data () {
    return {
      dateColumnIndexes: [
        'createdDate',
        'date',
        'dob',
        'effectiveDate',
        'emailLastSentDate',
        'expirationDate',
        'invoiceDate',
        'lastUpdatedDate',
        'memberDateOfBirth',
        'modifiedDate',
        'paidDate',
        'requestedDateMax',
        'statusDate',
        'submittedDt',
      ],
      dollarFormattedIndexes: [
        'displayAdjustmentAmount',
        'displayBalance',
        'displayInvoiceAmount',
        'displayPaidAmount',
      ]
    }
  },

  methods: {
    tableSorter (items, index, isDesc) {
      return items.sort((a, b) => {
        let sortA = a[index]
        let sortB = b[index]

        if (this.dateColumnIndexes.includes(index)) { 
          return this.dateSort(sortA, sortB, isDesc);
        } 
        else if (this.dollarFormattedIndexes.includes(index)) {
          return this.dollarSort(sortA, sortB, isDesc);
        } 
        else  {
          return this.defaultSort(sortA, sortB, isDesc);
        }
      })
    },

    dateSort (sortA, sortB, isDesc) {
      if (!isDesc) return new Date(sortA) - new Date(sortB)
      else return new Date(sortB) - new Date(sortA)
    },

    dollarSort (sortA, sortB, isDesc) {
      let numberSortA = 0.0
      let numberSortB = 0.0
      try {
        let dollarReggie = /[^0-9.-]+/g
        numberSortA = Number(sortA.replace(dollarReggie, ''))
        numberSortB = Number(sortB.replace(dollarReggie, ''))
      } catch (error) {
        console.error(error)
      }
      if (!isDesc) return numberSortA - numberSortB
      else return numberSortB - numberSortA
    },

    defaultSort (sortA, sortB, isDesc) {
    /*
      see vuetify codebase for more info:
      https://github.com/vuetifyjs/vuetify/blob/33f403342d3eccbd1a445c4c676bf8b02bce8303/packages/vuetify/src/mixins/data-iterable.js
     */

      if (isDesc) {
        [sortA, sortB] = [sortB, sortA]
      }

      // Check if both are numbers
      if (!isNaN(sortA) && !isNaN(sortB)) {
        return sortA - sortB
      }

      // Check if both cannot be evaluated
      if (sortA === null && sortB === null) {
        return 0
      }

      [sortA, sortB] = [sortA, sortB]
        .map(s => (
          (s || '').toString().toLocaleLowerCase()
        ))

      if (sortA > sortB) return 1
      if (sortA < sortB) return -1

      return 0
    }
  }
}
